import { getSupportChatUserApiService } from '@/api/sdk-api';
import {
  type SupportChatTokenProvider,
  type SupportChatVisitor,
  type SupportChatWidgetAdapter,
  useSupportChatWidget as useCoreSupportChatWidget,
} from '@marpla/core/support-chat';
import { useMemo } from 'react';

interface UseSupportChatWidgetOptions {
  adapter?: SupportChatWidgetAdapter;
  tokenProvider?: SupportChatTokenProvider;
}

export function useSupportChatWidget(
  visitor: SupportChatVisitor,
  options: UseSupportChatWidgetOptions = {},
): void {
  const userApiService = useMemo(() => getSupportChatUserApiService(), []);

  useCoreSupportChatWidget(visitor, userApiService, options);
}
